<template>
	<modal body-classes="p-0" :show="open" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0">
					เพิ่มผู้ใช้งาน
				</h2>
			</template>
			<template>
				<form @submit.prevent="addUser">
					<base-input
						label="ชื่อผู้ใช้งาน"
						placeholder="ชื่อผู้ใช้งาน"
						v-model="username"
						required
					/>
					<base-input
						type="password"
						label="รหัสผ่าน"
						placeholder="รหัสผ่าน"
						v-model="password"
						required
					/>

					<div class="row mt-4 mb-2">
						<div class="col-md-6" v-for="(perm, v) in permissions" :key="v">
							<base-checkbox :value="v" v-model="perms[v]">
								{{ perm }}
							</base-checkbox>
						</div>
					</div>

					<base-button class="mt-3" native-type="submit" type="default" :disabled="loading">
						เพิ่มผู้ใช้งาน
					</base-button>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import UserService from '../../services/user.service'

export default {
	props: ['open', 'permissions'],
	data() {
		return {
			loading: false,
			username: '',
			password: '',
			perms: {},
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		addUser() {
			this.loading = true
			UserService.addUser({
				username: this.username,
				password: this.password,
				permissions: this.perms,
			})
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})

					this.$emit('reloadUser')
					this.$emit('close')
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
}
</script>
